import Sport from '@maxpreps/shared/constants/sportName';
import {
  SUPPORT_COACHES_TEAM_ADMINS,
  SUPPORT_SCHEDULE_CORRECTIONS,
  SUPPORT_SCHEDULE_MANAGEMENT
} from '@maxpreps/shared/constants/supportArticles';
import { getPrintScheduleUrl } from '@maxpreps/shared/constants/urls';
import useTeamContext from '@maxpreps/shared/contexts/TeamContext';
import {
  getShotChart,
  getStatSheet
} from '@maxpreps/shared/functions/utils/printableGameDayForms';
import useIsAdmin from '@maxpreps/shared/hooks/useIsAdmin';
import { IConfigurableLink } from '@maxpreps/shared/models/configurableLink';
import CardFooterLinksContainer from '@maxpreps/shared/ui/Card/CardFooterLinksContainer';
import React from 'react';
import TeamSmartAnchor from '../shared/TeamSmartAnchor';
import useScheduleContext from './ScheduleContext';

const ScheduleLinksContainer = () => {
  const teamContext = useTeamContext();
  const scheduleContext = useScheduleContext();
  const isAdmin = useIsAdmin();

  const { data } = teamContext;
  const { teamId, sportSeasonId, sport, gender } = data;
  const {
    hasCorrectAScoreMode,
    isCorrectAScoreMode,
    setIsCorrectAScoreMode,
    isEligibleForPrint
  } = scheduleContext;

  const links: IConfigurableLink[] = [];

  if (isEligibleForPrint) {
    links.push({
      text: 'Print',
      as: 'a',
      asOptions: {
        href: getPrintScheduleUrl(teamId, sportSeasonId),
        target: '_blank'
      }
    });
  }

  if (!isAdmin) {
    links.push({
      text: 'Schedule Correction',
      as: 'a',
      asOptions: {
        href: SUPPORT_SCHEDULE_CORRECTIONS,
        target: '_blank'
      }
    });

    if (hasCorrectAScoreMode) {
      links.push({
        text: `${isCorrectAScoreMode ? 'Cancel ' : ''}Score Correction`,
        as: 'button',
        asOptions: {
          onClick: () => {
            setIsCorrectAScoreMode(!isCorrectAScoreMode);
          }
        }
      });
    }
  } else {
    links.push({
      text: 'Schedule Management Help',
      as: 'a',
      asOptions: {
        href: SUPPORT_SCHEDULE_MANAGEMENT
      }
    });

    links.push({
      text: 'Coach Support',
      as: 'a',
      asOptions: {
        href: SUPPORT_COACHES_TEAM_ADMINS
      }
    });

    const statSheet = getStatSheet(gender as any, sport as Sport);
    if (statSheet) {
      links.push({
        text: `Printable Stat Sheet`,
        as: 'a',
        asOptions: {
          href: statSheet.href,
          download: statSheet.fileName
        }
      });
    }

    const shotChart = getShotChart(sport);
    if (shotChart) {
      links.push({
        text: `Printable Shot Chart`,
        as: 'a',
        asOptions: {
          href: shotChart.href,
          download: shotChart.fileName
        }
      });
    }
  }

  return (
    <CardFooterLinksContainer links={links} anchorComponent={TeamSmartAnchor} />
  );
};

export default ScheduleLinksContainer;
